module.exports = __webpack_public_path__ + "img/Cloud_3.2285e526.png";